import { render, staticRenderFns } from "./DownLoad.vue?vue&type=template&id=f837ea74&scoped=true"
import script from "./DownLoad.vue?vue&type=script&lang=js"
export * from "./DownLoad.vue?vue&type=script&lang=js"
import style0 from "./DownLoad.vue?vue&type=style&index=0&id=f837ea74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f837ea74",
  null
  
)

export default component.exports